import { forwardRef, ReactNode, Ref, MouseEvent } from "react";
import { IsMobileAtom } from "../App";
import { useAtomValue } from "jotai";
import { Button, ButtonGroup } from "reactstrap";
import { Popover, Whisper } from "rsuite";
import { callFunctionIfExists } from "../utils/GeneralUtils";
import { TypeAttributes } from "rsuite/esm/internals/types";

interface NewButtonProps {
  title?: string;
  color?: string;
  placement?: TypeAttributes.Placement;
  disabled?: boolean;
  options?: ReactNode;
  onlyOptions: boolean;
  onlyNew?: boolean;
  buttonGroupCSS?: string;
  newButtonRef?: Ref<any>;
  onClick?: () => void;
  onOpen?: () => void;
  onClose?: () => void;
}

const NewButton = ({
  onClick,
  title = "New",
  color = "primary",
  newButtonRef,
  options,
  placement = "autoVerticalStart",
  buttonGroupCSS = "",
  onlyOptions = false,
  onlyNew = false,
  disabled,
  onOpen,
  onClose,
}: NewButtonProps) => {
  const mobileScreen = useAtomValue(IsMobileAtom);

  const ChevronButton = forwardRef((props, ref: any) => (
    <Button
      ref={ref}
      {...props}
      size="sm"
      color={color}
      className={`${
        mobileScreen ? "d-flex align-items-center justify-content-center" : ""
      } ${onlyOptions ? "" : "btn-icon-only"}`}
      disabled={disabled}
      style={{
        height: mobileScreen ? "36px" : "",
        width: mobileScreen ? "36px" : "",
      }}
    >
      {onlyOptions ? (
        <>
          <span
            className={!mobileScreen ? "d-none d-md-inline mr-1" : undefined}
            style={{ position: "relative", top: -4, left: 4 }}
          >
            {title}
          </span>
        </>
      ) : null}
      {onlyOptions ? (
        <i
          className={`mdi mdi-chevron-down  ${
            mobileScreen ? "pr-1" : "mr--1"
          }"`}
          style={{ fontSize: 22, lineHeight: 1, top: 0, position: "relative" }}
        ></i>
      ) : (
        <i className={`mdi mdi-chevron-down ${mobileScreen ? "pr-1" : ""}`}></i>
      )}
    </Button>
  ));

  return (
    <>
      {onlyOptions ? (
        <Whisper
          placement={placement}
          trigger="click"
          ref={newButtonRef}
          onOpen={() => callFunctionIfExists(onOpen)}
          onClose={() => callFunctionIfExists(onClose)}
          speaker={
            <Popover
              className="sidebar-popover"
              full
              onClick={(e: MouseEvent) => {
                e.stopPropagation();
              }}
            >
              {options}
            </Popover>
          }
          controlId="newRecordDropdown"
        >
          <ChevronButton />
        </Whisper>
      ) : (
        <ButtonGroup className={buttonGroupCSS}>
          <Button
            size="sm"
            color={color}
            className={
              mobileScreen ? "d-flex align-items-center w-100" : "px-1 px-md-2"
            }
            onClick={onClick}
            disabled={disabled}
            style={{
              height: mobileScreen ? "36px" : "",
              width: mobileScreen ? "42px" : "",
              fontSize: mobileScreen ? 12 : "",
            }}
          >
            <span>{title}</span>
          </Button>
          {!onlyNew && (
            <Whisper
              placement={placement}
              trigger="click"
              onOpen={() => callFunctionIfExists(onOpen)}
              onClose={() => callFunctionIfExists(onClose)}
              ref={newButtonRef}
              speaker={
                <Popover
                  className="sidebar-popover"
                  full
                  onClick={(e: MouseEvent) => {
                    e.stopPropagation();
                  }}
                >
                  {options}
                </Popover>
              }
              controlId="newRecordDropdown"
            >
              <ChevronButton />
            </Whisper>
          )}
        </ButtonGroup>
      )}
    </>
  );
};

export default NewButton;
